import { useContext, useState } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { UKKProtocol } from '~/modules/aerobicCapabilities/schema'
import { studentEvaluationDemoContext } from '~/pages/authenticated/personalTrainer/studentEvaluationDemo'

export const UKK: React.FC = () => {
  const { data } = useContext(studentEvaluationDemoContext)
  const [value] = useState<UKKProtocol>({
    heartRate: data?.ukk?.heartRate ?? 0,
    time: data?.ukk?.time ?? 0,
  })

  return (
    <div className='flex gap-3'>
      <MaskedInput
        mask='float'
        inputMode='numeric'
        label='Tempo (min)'
        placeholder='0'
        value={value.time}
        onChange={() => undefined}
      />
      <MaskedInput
        mask='float'
        inputMode='numeric'
        label='Frequência Cardíaca Final (bpm)'
        placeholder='0'
        value={value.heartRate}
        onChange={() => undefined}
      />
    </div>
  )
}
